import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EoHttpClient, IHttpParams } from '../../common/eo-http-client.service';
import { STATUS } from '../../common/use-loading.model';
import { IPickList } from './picklist.model';
import { picklistproducts, picklistproductsSelected } from './picklist.mock';

@Injectable({
  providedIn: 'root',
})
export class EoPickListService<T> {
  source = new BehaviorSubject<IPickList[]>([]);
  status$ = new BehaviorSubject<STATUS>(STATUS.pending);
  error$ = new BehaviorSubject<string | null>(null);

  constructor(
    @Inject('apiUrl') private readonly apiUrl: string,
    private http: EoHttpClient
  ) {}

  fetchSource(url: string): Observable<T[]> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.source,
      status$: this.status$,
      error$: this.error$,
    };

    return this.http.get<T[]>(param);
  }
}
